import { type FC } from "react";

import { ColoredLabel } from "widgets";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const UserStatusCell: FC<IAgGridCellProps> = (props) => {
  return (
    <TableCell>
      {props.value ? (
        <ColoredLabel color={"#98C375"}>Active</ColoredLabel>
      ) : (
        <ColoredLabel color={"#CB5271"}>Disabled</ColoredLabel>
      )}
    </TableCell>
  );
};

export default UserStatusCell;
